/**
 * Instruction collection context.
 *
 * Provides a mechanism for components (including tools) to register
 * instruction sections that will be included in the LLM system prompt.
 */

import { createContext } from 'react';

import type { InstructionContextType } from '#plugin-chat/lib/instructions/types.ts';

/** Default no-op context for when used outside InstructionProvider */
export const InstructionContext = createContext<InstructionContextType>({
  registerInstruction: () => () => {
    // No-op cleanup when used outside InstructionProvider
  },
  getInstructions: () => [],
});
